/* Progressive enhancement only. No cart, account, checkout or business state writes. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setups = new WeakMap();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-nova-cinema]').forEach(hero => {
      if (setups.has(hero)) return;
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('.nova-cinema__toggle');
      if (!video || !toggle) return;
      const controller = new AbortController();
      setups.set(hero, controller);
      const opts = { signal: controller.signal };
      let userPaused = false;
      let loaded = false;
      const sync = () => {
        const playing = !video.paused && !video.ended;
        toggle.querySelector('[data-cinema-icon]').textContent = playing ? 'Ⅱ' : '▷';
        toggle.querySelector('[data-cinema-label]').textContent = playing ? 'Mettre en pause' : 'Lire la vidéo';
        toggle.setAttribute('aria-label', playing ? 'Mettre en pause la vidéo d’ambiance' : 'Lire la vidéo d’ambiance');
      };
      const play = () => {
        if (!loaded) {
          video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
          video.muted = true;
          video.load();
          loaded = true;
        }
        video.play().catch(sync);
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      }, opts);
      video.addEventListener('playing', () => { hero.classList.add('is-playing'); sync(); }, opts);
      video.addEventListener('pause', sync, opts);
      video.addEventListener('error', () => { hero.classList.remove('is-playing'); toggle.hidden = true; }, opts);
      const shouldAutoplay = () => !motion.matches && !navigator.connection?.saveData && !userPaused;
      if (shouldAutoplay()) play();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (shouldAutoplay()) play();
      }, opts);
      motion.addEventListener('change', () => { if (motion.matches) video.pause(); }, opts);
      sync();
    });
    if ('IntersectionObserver' in window && !motion.matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('nova-arrive'); observer.unobserve(entry.target); }
        });
      }, { threshold: .08 });
      scope.querySelectorAll('.nova-home-v41 > .nova-section').forEach(el => observer.observe(el));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-nova-cinema]').forEach(hero => {
      hero.querySelector('video')?.pause();
      setups.get(hero)?.abort();
      setups.delete(hero);
    });
  });
})();
